module.exports = __webpack_public_path__ + "img/SCCY1.94437df3.jpg";